import axiosService from '../../services/axios.service';
import { getEndpointBase } from '../../services/api.service';
import {
  CalendarEventCreatePayload,
  CalendarEventUpdatePayload,
} from './Calendar.type';

const CalendarService = {
  getInterviewsByPerson(personId: number) {
    return axiosService.get(getEndpointBase(`people/${personId}/interviews`));
  },

  createEvent(payload: CalendarEventCreatePayload) {
    const { personId, personRecordId, ...body } = payload;
    return axiosService.post(
      getEndpointBase(
        `people/${personId}/records/${personRecordId}/interviews`,
      ),
      body,
    );
  },

  getEvent(eventId: string) {
    return axiosService.get(getEndpointBase(`event/interview/${eventId}`));
  },

  updateEvent(eventId: string, payload: CalendarEventUpdatePayload) {
    return axiosService.patch(
      getEndpointBase(`event/interview/${eventId}`),
      payload,
    );
  },

  deleteEvent(interviewId: number) {
    return axiosService.delete(
      getEndpointBase(`event/interview/${interviewId}`),
    );
  },
};

export default CalendarService;
